// usePayableDetail.ts

import { useDispatch, useSelector } from "react-redux";

import { AppDispatch, RootState } from "../../../../store/store";

import useLoading from "../../../../hooks/useLoading";
import useApiErrorHandler from "../../../../hooks/useApiErrorHandler";

import PayableDetailService from "../services/PayableDetail.service";

import {
  clearPayableDetail,
  closeDetailModal,
  openDetailModal,
  setError,
  setLoading,
  setPayableDetail,
} from "../store/PayableDetail.slice";

export const usePayableDetail = () => {
  const dispatch: AppDispatch = useDispatch();

  const {
    showLoadingIndicator,
    hideLoadingIndicator,
  } = useLoading();
  const { handle } = useApiErrorHandler();

  const {
    detail,
    loading,
    error,
    isModalOpen,
    selectedPayableId,
  } = useSelector(
    (state: RootState) => state.payableDetail
  );

  /**
   * 📌 Obtener detalle por ID
   */
  const fetchPayableDetail = async (
    PayableId: number
  ) => {
    try {
      dispatch(setLoading(true));
      showLoadingIndicator();

      const data =
        await PayableDetailService.getById(
          PayableId
        );

        console.log(data);

      dispatch(setPayableDetail(data));

      return data;
    } catch (err: any) {
      dispatch(
        setError(
          "Error al obtener detalle de Cuenta por Pagar"
        )
      );

      dispatch(clearPayableDetail());
      handle(
        err,
        "No fue posible obtener el detalle de la Cuenta por Pagar."
      );

      return null;
    } finally {
      dispatch(setLoading(false));
      hideLoadingIndicator();
    }
  };

  /**
   * 🪟 Abrir modal + cargar detalle
   */
  const handleOpenDetailModal = async (
    PayableId: number
  ) => {
    dispatch(openDetailModal(PayableId));

    await fetchPayableDetail(PayableId);
  };

  /**
   * ❌ Cerrar modal + limpiar state
   */
  const handleCloseDetailModal = () => {
    dispatch(closeDetailModal());
    dispatch(clearPayableDetail());
  };

  /**
   * 🧹 limpieza manual
   */
  const clearDetail = () => {
    dispatch(clearPayableDetail());
  };

  return {
    // state
    detail,
    loading,
    error,
    isModalOpen,
    selectedPayableId,

    // actions
    fetchPayableDetail,
    handleOpenDetailModal,
    handleCloseDetailModal,
    clearDetail,
  };
};
